import { Box, Stack, Typography } from '@mui/material'
import React, { useContext } from 'react'

import TrackedExternalLink from 'components/common/TrackedExternalLink'
import { TutorialStep } from 'components/common/TutorialStep'
import Icon from 'components/Icon'
import { ObservabilityToolAuthenticationContext } from 'context/status-checks/ObservabilityToolAuthenticationContext'
import { useTranslation } from 'hooks/use-translation'
import { getAWSPolicyNameFromManagedPolicyArn } from 'utils/status-checks/status-check-integrations-util-aws'

export const ManagedPolicies: React.FC<{ badgeCount: number }> = ({
  badgeCount
}) => {
  const { trans } = useTranslation()
  const { awsIAMRoleMetadata } = useContext(
    ObservabilityToolAuthenticationContext
  )

  return (
    <TutorialStep
      badgeNumber={badgeCount}
      title={trans(
        'status_checks.authentication.aws.iam_role.manual_method.step_4.title'
      )}
    >
      <Box ml={1} mt={1}>
        <Stack spacing={1}>
          <Typography>
            {trans(
              'status_checks.authentication.aws.iam_role.manual_method.step_4.description'
            )}
          </Typography>
          {Boolean(awsIAMRoleMetadata?.managedPolicies?.length) &&
            awsIAMRoleMetadata?.managedPolicies.map((policy) => (
              <TrackedExternalLink
                key={policy}
                eventName="AWSManagedPolicyClicked"
                href={`https://console.aws.amazon.com/iam/home#/policies/details/${encodeURIComponent(
                  policy
                )}?section=entities_attached`}
              >
                <Stack alignItems="center" direction="row" spacing={1}>
                  <Typography>
                    {getAWSPolicyNameFromManagedPolicyArn(policy)}
                  </Typography>
                  <Icon icon="arrowUpRightFromSquare" />
                </Stack>
              </TrackedExternalLink>
            ))}
        </Stack>
      </Box>
    </TutorialStep>
  )
}
